/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Typed facade over src/lib/readingTimeCore.js — the implementation lives in
 * plain JS so the server (/api/articles readingMinutes) and prerender.mjs
 * (SSR index seed) can share the exact same algorithm. Client code keeps
 * importing from this module; the public API is unchanged.
 */

import type { ArticleContentBlock } from '../pages/admin/articleTypes';
import type { Language } from '../contexts/LanguageContext';
import {
  totalWordCount as coreTotalWordCount,
  estimateReadingMinutes as coreEstimateReadingMinutes,
  readingTimeISO as coreReadingTimeISO,
} from './readingTimeCore';

export function totalWordCount(blocks: ArticleContentBlock[]): number {
  return coreTotalWordCount(blocks);
}

export function estimateReadingMinutes(blocks: ArticleContentBlock[], language: Language): number {
  return coreEstimateReadingMinutes(blocks, language);
}

// ISO 8601 duration for schema.org Article.timeRequired (e.g. "PT5M").
export function readingTimeISO(minutes: number): string {
  return coreReadingTimeISO(minutes);
}
